/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ErrorIndicatorIcon = createIcon("ErrorIndicatorIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#AB0000';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "36",
    height: "20",
    viewBox: "0 0 36 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M28 0H0v20h28V0Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m36 10-8 10V0l8 10Z",
    fill: _color
  }));
}, {
  "replaceColor": true
});